import './table301/style';
import FormStructure from './table301/form_structure';

export default FormStructure;